exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "table{width:100%;margin-bottom:.8em}td,th{border:1px solid #212529;padding:2px 10px}th{text-align:center}td{font-size:90%}a{color:#005092;font-weight:600;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/layouts/footer/mention-legale/mention-legale.component.scss
// module id = 701
// module chunks = 0